<script lang="ts" setup>
import { Button, Icon } from '@brighterly/lib-lumee-ui'

import { useSubscriptionStore } from '@stores/subscription'

import { useFailedPaymentRetry } from '@hooks/subscription/failed-payment-retry.hook'

import amplitudeConf from '@config/amplitude.json'

import { trackEvent } from '@tools/amplitude'

defineOptions({
  name: 'BannerFailed',
})

const subscriptionStore = useSubscriptionStore()

const {
  btnText,
  setSubmit,
} = useFailedPaymentRetry()

onMounted(() => {
  trackEvent(amplitudeConf.events.bannerView, {
    banner_name: 'retry_payment',
  })
})
</script>

<template>
  <div class="failed">
    <div class="failed__info">
      <span class="failed__icon">
        <Icon
          name="triangle-exclamation"
          weight="solid"
          size="sm"
          color="inherit"
        />
      </span>
      <div class="failed__title">
        <span class="failed__warn">⚠️</span> <span class="main btly-text-title-s">
          {{ subscriptionStore.getPaymentRetryErrorTitle }}
        </span>
        <br class="failed__break">
        <span class="common">
          {{ subscriptionStore.getPaymentRetryErrorText }}
        </span>
      </div>
    </div>
    <span class="failed__retry">
      <Button
        size="sm"
        view="destructive"
        fill
        :text="btnText"
        @click="setSubmit"
      />
    </span>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Others/BannerRetryPayment/BannerFailed.scss" />
